import datepicker from 'js-datepicker';
import {
  getUTMS,
  setUtmCookie,
  setUtmSession,
  UTMParameters,
} from './UTMHelper';
import { easterDate, getHolidayDates } from './HolidaysCalendar';

function populateCountryField() {
  const countryFields = document.querySelectorAll('[name="fields[country]"]');
  const phoneFields = document.querySelectorAll(
    '[data-field-type="phone"] input[type="tel"], '
    + '[data-field-type="phoneNumber"] input[type="tel"]',
  );
  if (countryFields.length > 0 || phoneFields.length > 0) {
    fetch('/get-country-code-from-ip/', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.countryCode) {
          countryFields.forEach((countryField) => {
            // @ts-ignore
            // eslint-disable-next-line no-param-reassign
            (countryField as HTMLSelectElement).value = data.countryCode;
          });

          phoneFields.forEach((phoneField) => {
            // @ts-ignore
            if (phoneField.validator) {
              // @ts-ignore
              phoneField.validator.setCountry(data.countryCode);
            }
          });
        }
      })
      // eslint-disable-next-line no-console
      .catch((err) => console.error('Country code not fetched.', err));
  }
}

function loadTabs(formWrap: HTMLElement, nextPageIndex: number) {
  const tabs = formWrap.querySelectorAll('.tabs-progress li');
  const pageTabs = formWrap.querySelectorAll('.tabs-pages li');

  tabs.forEach((tab: Element, index: number) => {
    tab.classList.remove('completed', 'active');

    if (index < nextPageIndex) {
      tab.classList.add('completed');
    } else if (index === nextPageIndex) {
      tab.classList.add('active');
    }
  });

  pageTabs.forEach((tab, index) => {
    tab.classList.remove('active');

    if (index === nextPageIndex) {
      tab.classList.add('active');
    }
  });
}

function didUserAllowedCookies() {
  const match = document.cookie.match(/cookiehub=([^;]+)/);
  if (!match) return false;

  try {
    const cookiesDecoded = JSON.parse(atob(match[1].split('.')[0] || match[1]));
    return cookiesDecoded.allAllowed === true;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('@didUserAllowedCookies', error);
    return false;
  }
}

function attachCookieListeners() {
  const acceptBtns = document.querySelectorAll('.ch2-allow-all-btn');
  const saveBtn = document.querySelector('.ch2-save-settings-btn') as HTMLElement;

  acceptBtns.forEach((btn) => {
    const button = btn as HTMLElement;
    if (!button.dataset.listener) {
      button.dataset.listener = 'true';
      button.addEventListener('click', () => {
        setUtmCookie(true);
      });
    }
  });

  if (saveBtn && !saveBtn.dataset.listener) {
    saveBtn.dataset.listener = 'true';
    saveBtn.addEventListener('click', () => {
      const checkboxMarketingCookies = document.getElementById('c2-c-4') as HTMLInputElement;
      const { partial } = checkboxMarketingCookies.dataset;
      if (partial !== undefined) {
        setUtmCookie(checkboxMarketingCookies.checked);
      }
    });
  }
}

function updateUTMs(form: HTMLFormElement, data: UTMParameters) {
  if (form) {
    const source = form.querySelector('[name="fields[utmSource]"]') as HTMLInputElement;
    if (source) {
      source.value = data.utm_source ?? 'Organic';
    }
    const medium = form.querySelector('[name="fields[utmMedium]"]') as HTMLInputElement;
    if (medium) {
      medium.value = data.utm_medium ?? 'Organic';
    }
    const campaign = form.querySelector('[name="fields[utmCampaign]"]') as HTMLInputElement;
    if (campaign) {
      campaign.value = data.utm_campaign ?? 'Organic';
    }
    const Referrer = form.querySelector('[name="fields[utmReferrer]"]') as HTMLInputElement;
    if (Referrer) {
      Referrer.value = data.referrerUrl ?? '';
    }
  }
}

async function setUtmValues() {
  if (document.querySelectorAll('[name="fields[leadSource]"]').length > 0) {
    const forms = document.querySelectorAll('form');
    if (forms.length > 0) {
      const dataUTMs = await getUTMS();
      if (dataUTMs) {
        forms.forEach((form) => {
          updateUTMs(form, dataUTMs);
        });
      }
    }
  }
}

function setIsAppleUser() {
  const isAppleDevice = /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
  if (isAppleDevice) {
    const isAppleUserFields = document.querySelectorAll('[name="fields[isAppleUser]"]');
    isAppleUserFields.forEach((field) => {
      const isAppleUser = field as HTMLInputElement;
      isAppleUser.checked = true;
      isAppleUser.value = '1';
      isAppleUser.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
}

function loadUTMs() {
  if (window.location.search.includes('utm_')) {
    if (didUserAllowedCookies()) {
      setUtmCookie(true);
    } else {
      setUtmSession(true);
    }
  }

  window.addEventListener('utmDataStored', async () => {
    await setUtmValues();
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(() => attachCookieListeners());
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
}

export default function initForms() {
  const currentPath = window.location.pathname;
  const selector = 'form input[name="fields[currentUrlPath]"]';
  const currentPathField = document.querySelector(selector) as HTMLInputElement;

  let value = '';
  if (currentPathField) {
    if (currentPath.includes('executive-education')) {
      value = 'executive-education';
    } else if (currentPath.includes('cscfs')) {
      value = 'cscfs';
    }
    currentPathField.value = value;
  }
  document.addEventListener('readystatechange', async (event) => {
    const target = event.target as Document;
    if (target && target.readyState === 'complete') {
      await setUtmValues();
      setIsAppleUser();
    }
  });

  if (window.BLITZ_CACHE_ENABLED) {
    document.addEventListener('afterBlitzInject', () => {
      populateCountryField();
    });
    document.addEventListener('afterBlitzInjectAll', () => {
      loadUTMs();
    });
  } else {
    populateCountryField();
    loadUTMs();
  }

  document.addEventListener('onFormieInit', async (event: Event) => {
    // @ts-ignore
    const formie = event.detail.$form;
    const handle = formie.querySelector('[name="handle"]').value;

    if (handle === 'downloadBrochureIndividual') {
      const params = new URLSearchParams(window.location.search);
      const program = params.get('program');
      const programField = formie.querySelector('[name="fields[programOfInterest]"]');

      if (program && programField) {
        programField.value = program.toLocaleLowerCase();
      }
    }

    const fileUploads = document.querySelectorAll('.custom-file-upload');

    fileUploads.forEach((fileUploadField) => {
      const fileUpload = fileUploadField.querySelector('input[type="file"]');
      if (fileUpload) {
        fileUpload.addEventListener('change', (changeEvent: Event) => {
          const input = changeEvent.target as HTMLInputElement;
          if (input) {
            const fileLabel = input.parentNode?.querySelector('.label');
            if (fileLabel) {
              if (input.files && input.files.length > 0) {
                fileLabel.textContent = input.files[0].name;
              } else {
                fileLabel.textContent = 'No file selected';
              }
            }
          }
        });
      }
    });

    const calendarInputs = document.querySelectorAll(
      'input[data-fui-id="rentalRequest-preferredDate"], '
      + 'input[data-fui-id="appointmentRequest-preferredDate"]',
    );
    if (calendarInputs.length > 0) {
      try {
        const currentYear = new Date().getFullYear();
        const easter = easterDate(currentYear);
        const goodFriday = new Date(easter);
        goodFriday.setDate(easter.getDate() - 2);
        const easterMonday = new Date(easter);
        easterMonday.setDate(easter.getDate() + 1);
        const ascension = new Date(easter);
        ascension.setDate(easter.getDate() + 39);
        const whitMonday = new Date(easter);
        whitMonday.setDate(easter.getDate() + 50);

        calendarInputs.forEach((calendarInput) => {
          datepicker(calendarInput as HTMLInputElement, {
            startDay: 1,
            noWeekends: true,
            startDate: new Date(new Date().setDate(new Date().getDate() + 1)),
            minDate: new Date(new Date().setDate(new Date().getDate() + 2)),
            disabler: getHolidayDates,
          });
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('Date Picker initialization failed. Reason ::', e);
      }
    }

    const formsWithTabs = document.querySelectorAll('.has-pages');
    if (formsWithTabs.length > 0) {
      formsWithTabs.forEach((form) => {
        loadTabs(form as HTMLElement, 0);
      });
    }

    const enableProgramCheckboxes = document.querySelectorAll('input[type="checkbox"]');
    enableProgramCheckboxes.forEach((input) => {
      const checkbox = input as HTMLInputElement;
      if (checkbox.value === 'enable') {
        checkbox.value = '1';
        checkbox.checked = true;
      }
    });

    // @ts-ignore
    event.detail.formie.refreshForCache(event.detail.formId);
  });

  document.addEventListener('onAfterFormieSubmit', (event: Event) => {
    //  @ts-ignore
    const { nextPageIndex } = event.detail;
    const formsWithTabs = document.querySelectorAll('.has-pages');
    if (formsWithTabs.length > 0) {
      formsWithTabs.forEach((formWrap) => {
        loadTabs(formWrap as HTMLElement, Number(nextPageIndex));
      });
    }
  });
}
